// @flow
import React from "react";
import Typography from "../Typography";

type Props = {
  cypress: string | null,
  error: string,
  className: string
};

const Error = ({ error, className, cypress }: Props) => (
  <Typography size="secondary" color="error">
    <div className={`c-error ${className}`} data-cy={cypress} role="alert">
      {error}
    </div>
  </Typography>
);

Error.defaultProps = {
  className: "",
  cypress: null
};

export default Error;
